module.exports = __webpack_public_path__ + "img/image_gallery5.25aea459.jpg";